import { ValidatorFn, ValidationErrors, FormArray, AbstractControl } from '@angular/forms';
import { setError } from './setError';

export function DictionaryValidator(key: string): ValidatorFn {
    return (array: AbstractControl): ValidationErrors | null => {
        if (!(array instanceof FormArray)) {
            return null;
        }

        const keys: Set<string> = new Set<string>();
        if (array.controls.length) {
            array.controls.forEach(group => {
                const control = group.get(key);
                if (control) {
                    const value = control.value;
                    if (keys.has(value)) {
                        setError(control, { dictionary: 'Duplicate dictionary key value.'}, 'dictionary')
                    } else {
                        keys.add(value);
                    }
                }
            });
        }

        return null
    };
}


